import { render } from "./ErrorArea.vue?vue&type=template&id=79e25e5d&scoped=true"
import script from "./ErrorArea.vue?vue&type=script&lang=js"
export * from "./ErrorArea.vue?vue&type=script&lang=js"

import "./ErrorArea.vue?vue&type=style&index=0&id=79e25e5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e25e5d"]])

export default __exports__